import { render } from "./AIAssessment.vue?vue&type=template&id=97849ac0"
import script from "./AIAssessment.vue?vue&type=script&lang=js"
export * from "./AIAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__